import { Heading } from "@app/_components/ui";

import { useCheckoutContext } from "./Checkout.hooks";
import { checkoutStore } from "./Checkout.store";
import CheckoutPaymentMethods from "./CheckoutPaymentMethods";

export default function CheckoutPayment() {
  const { dictionary, paymentStepRef } = useCheckoutContext();
  const deliveryOption = checkoutStore((state) => state.deliveryOption);

  if (!deliveryOption) return null;

  return (
    <div
      ref={paymentStepRef}
      className="scroll-mt-[3rem] px-5 py-6 lg:scroll-mt-[4rem] lg:px-16 lg:py-10"
    >
      {dictionary.checkoutPaymentHeading && (
        <Heading size={5} className="mb-6 text-center">
          {dictionary.checkoutPaymentHeading}
        </Heading>
      )}
      <CheckoutPaymentMethods />
    </div>
  );
}
